// extracted by mini-css-extract-plugin
export default {"header":"DkA9uLEQh-lo59g-UYvCBg==","title":"Gyb88czga521bh6n4KwULQ==","heading":"_6BDEoEgJboWiRnjcakY-Mg=="};